import { FC } from 'react';
import classNames from 'classnames/bind';
import { IndividualTogglePropTypes } from '../types/IndividualTogglePropTypes';
import { FAIcon } from '../../Icons/Icons';
import styles from './IndividualToggle.module.scss';

const cx = classNames.bind(styles);

const IndividualToggle: FC<IndividualTogglePropTypes> = ({
  text,
  icon,
  isActive = false,
  theme,
  disabled,
  className,
  ...restProps
}: IndividualTogglePropTypes) => {
  const CClassname = cx(
    'individual-container',
    {
      [`${icon ? 'icon' : 'text'}-container`]: true,
      ...(disabled
        ? { disabled: true }
        : {
            inactive: !isActive,
            theme,
          }),
    },
    className,
  );
  return (
    <div {...restProps} className={CClassname} data-testid="individual-test-id">
      {icon ? <FAIcon {...icon} theme={theme} className={styles['icon']} /> : text}
    </div>
  );
};

export default IndividualToggle;
